// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Gloock_d859d8'","fontWeight":400,"fontStyle":"normal"},"className":"__className_d859d8"};